export const stringToBase64 = (value) => {
  const bytes = new TextEncoder().encode(value);
  let binary = '';
  bytes.forEach(b => binary += String.fromCharCode(b));
  return btoa(binary);
}

export const base64ToString = (base64) => {
  const binary = atob(base64);
  const bytes = new Uint8Array(
    [...binary].map(char => char.charCodeAt(0))
  );
  return new TextDecoder().decode(bytes);
}